var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationPrefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62305 19.75C3.37219 18.5982 4.39717 17.6517 5.60492 16.9965C6.81267 16.3412 8.16495 15.998 9.53898 15.998C10.913 15.998 12.2653 16.3412 13.473 16.9965C14.6808 17.6517 15.7058 18.5982 16.4549 19.75",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53894 14C11.7481 14 13.5389 11.8174 13.5389 9.125C13.5389 6.43261 11.7481 4.25 9.53894 4.25C7.3298 4.25 5.53894 6.43261 5.53894 9.125C5.53894 11.8174 7.3298 14 9.53894 14Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0284 13.413C16.073 13.4602 17.8296 14.1061 18.7206 14.7416C19.6116 15.377 20.3515 16.2702 20.8729 17.3399",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1411 6.32009C15.5359 6.20013 15.9348 6.19545 16.3092 6.3064C16.6835 6.41735 17.0241 6.64118 17.3067 6.9619C17.5893 7.28261 17.8068 7.6923 17.9437 8.16168C18.0807 8.63107 18.1336 9.14856 18.0989 9.67718C18.0641 10.2058 17.9424 10.7325 17.7425 11.2197C17.5426 11.7068 17.2695 12.1424 16.9426 12.4952C16.6157 12.8481 16.2432 13.1095 15.8516 13.2609C15.4599 13.4122 15.0589 13.4498 14.6772 13.3708",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationPrefill);
export default __webpack_public_path__ + "static/media/registrationPrefill.ec2ca667d4945c4801a4a63e68b70379.svg";
export { ForwardRef as ReactComponent };